import { gql } from '@apollo/client';
import get from 'lodash/get';
import camelCase from 'lodash/camelCase';
import { withQuery } from 'apollo-map-props';

export const GET_DEFAULT_PERMISSIONS = gql`
  query defaultPermissions {
    defaultPermissions {
      slug
      authorized
    }
  }
`;

function mapProps() {
  return {
    query: GET_DEFAULT_PERMISSIONS,
  };
}

function mapResultToProps({ data, loading }) {
  const flags = get(data, 'defaultPermissions', []);
  const flagProps = flags.reduce((acc, { slug, authorized }) => {
    return { ...acc, [camelCase(slug)]: authorized };
  }, {});
  return {
    ...flagProps,
    flagsLoading: loading,
  };
}

export default withQuery(mapProps, mapResultToProps);
